import type { VideoDirectorDraftV1 } from './videoDirectorTypes'

/**
 * Spec §二十五 — DRAFT_PERSISTENCE = PARTIAL this round.
 *
 * There is no backend model for this workflow's draft yet (spec §二十四
 * explicitly keeps this round's backend scope to UI/frontend IA only),
 * so this is real `sessionStorage` persistence (survives a refresh
 * within the same tab/session), never a fake "saved to server" claim.
 * A future round can add a real `PUT /video-generation/director-draft`
 * backend contract using this exact same `VideoDirectorDraftV1` shape
 * without a frontend rewrite.
 */
const KEY_PREFIX = 'vistoera.video_director_draft_v1.'

export function loadVideoDirectorDraft(workspaceId: string): VideoDirectorDraftV1 | null {
  try {
    const raw = sessionStorage.getItem(KEY_PREFIX + workspaceId)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed?.schema_version !== 'video_director_draft_v1') return null
    return parsed as VideoDirectorDraftV1
  } catch {
    return null
  }
}

export function saveVideoDirectorDraft(workspaceId: string, draft: VideoDirectorDraftV1): void {
  try {
    sessionStorage.setItem(KEY_PREFIX + workspaceId, JSON.stringify(draft))
  } catch {
    /* best-effort only — never block the UI on storage quota errors */
  }
}

export function clearVideoDirectorDraft(workspaceId: string): void {
  try {
    sessionStorage.removeItem(KEY_PREFIX + workspaceId)
  } catch {
    /* ignore */
  }
}
